import * as React from "react";

import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { FaHourglass } from "react-icons/fa6";
import SkeletonWrapper from "../components/SkeltonWrapper";

export const SignInButton = () => {
    const { instance } = useMsal();
    const [loading, setLoading] = React.useState(false);
    const handleLogin = () => {
        setLoading(true);
        instance.loginRedirect({ ...loginRequest, tokenQueryParameters: { context: DefaultOrganization }, extraQueryParameters: { context: DefaultOrganization } });
    };

    return (
        <div>
            <SkeletonWrapper loading={loading}>
                <button
                    onClick={() => handleLogin()}
                    className="px-4 py-2 bg-brand text-white rounded-md hover:bg-brand-dark transition-colors font-normal"
                >
                    Login
                </button>
            </SkeletonWrapper>
        </div>
    );
};
